import { render, staticRenderFns } from "./tabOrderInfo.vue?vue&type=template&id=058b71ec&"
import script from "./tabOrderInfo.vue?vue&type=script&lang=js&"
export * from "./tabOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./tabOrderInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('058b71ec')) {
      api.createRecord('058b71ec', component.options)
    } else {
      api.reload('058b71ec', component.options)
    }
    module.hot.accept("./tabOrderInfo.vue?vue&type=template&id=058b71ec&", function () {
      api.rerender('058b71ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/FBA/Order/tabOrderInfo.vue"
export default component.exports